(function () {'use strict';}());
angular.module("app").directive('landingView', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'views/landing.html?version=1.0',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
      }  
    };
  });